import React from "react";
import {
  Button,
  Card,
  Row,
  Col,
  Form,
  Modal,
} from "react-bootstrap";
import { useEffect, useState } from "react";


function ModalForAnnounce(props) {
  const [formData, setFormData] = useState({
    Comments: "",
  });

  const {
    Comments,
  } = formData;


  useEffect(() => {
    // This effect runs once after the initial render because of the empty dependency array [].
    const todayStr = new Date().toISOString().slice(0, 10);
    
  }, []); // <-- Empty array means this runs only once on mount.

  
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  
  return (
    <div>
      <Modal
        show={props.showPrimaryModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            HISD Announcements
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Card style={{ marginTop: "20px", backgroundColor: "#f7f6f2" }}>
              <Card.Title>Announcements</Card.Title>
              <Card.Body>
                <Row>
                  <Form.Group as={Col}>
                    <Form.Label>My Announcement</Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={4}
                      id="Comments"
                      name="Comments"
                      //value={Comments}
                      onChange={(e) => onChange(e)}
                      value="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
                    />
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={props.handleClosePrimary()}
            id="btnClosePrimary"
          >
            {props.close}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}


export default ModalForAnnounce;
